"use strict";
import "../sass/main.scss";
import { popup } from "./Popup";
import { smoothScroll } from "./SmoothScroll";

smoothScroll();
popup();
